import { Box } from 'components/Box'
import { FC, ReactNode } from 'react'
import { MediaTokens } from 'stitches.config'

type ResponsiveProps = {
  breakpoint: MediaTokens
  children?: ReactNode
}

export const Mobile: FC<ResponsiveProps> = ({ children, breakpoint }) => {
  return <Box css={{ display: 'initial', [`@${breakpoint}`]: { display: 'none' } }}>{children}</Box>
}

export const Desktop: FC<ResponsiveProps> = ({ children, breakpoint }) => {
  return <Box css={{ display: 'none', [`@${breakpoint}`]: { display: 'initial' } }}>{children}</Box>
}
